module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/6bcb77943c4f72322e154302a761f456.png";